import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListInstalacion(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/list-instalacion",
            API_BASE_URL + "/instalacion/list-instalacion",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].fechainstalacion = moment.utc(data[i].fechainstalacion).format("DD/MM/YYYY");
                    if (data[i].fechadesinstalacion !== null) {
                        data[i].fechadesinstalacion = moment.utc(data[i].fechadesinstalacion).format("DD/MM/YYYY");
                    }
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.descripcion,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListInstalacion err");
        console.log(err);
        return [];
    }
}

export async function createInstalacion(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/create-instalacion",
            API_BASE_URL + "/instalacion/create-instalacion",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createInstalacion err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableInstalacion(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/disable-instalacion",
            API_BASE_URL + "/instalacion/disable-instalacion",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableInstalacion err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function infoInstalacion(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/info-instalacion",
            API_BASE_URL + "/instalacion/info-instalacion",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("getListInstalacion err");
        console.log(err);
        return null;
    }
}

export async function getListInstalacionByCompany(obj, tag) {
    try {
        let data = [];
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/list-instalacion-by-company",
            API_BASE_URL + "/instalacion/list-instalacion-by-company",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            for (let i = 0; i < data.length; i++) {
                data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                data[i].fechainstalacion = moment.utc(data[i].fechainstalacion).format("DD/MM/YYYY");
                if (data[i].fechadesinstalacion !== null) {
                    data[i].fechadesinstalacion = moment.utc(data[i].fechadesinstalacion).format("DD/MM/YYYY");
                }
                data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
            }
        }
        if (code === FAILURE) {
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("getListInstalacionByCompany err");
        console.log(err);
        return [];
    }
}

export async function allInfoInstalacion(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/instalacion/all-info-instalacion",
            API_BASE_URL + "/instalacion/all-info-instalacion",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data = body[0];
            }
        }
        return data;
    } catch (err) {
        console.log("allInfoInstalacion err");
        console.log(err);
        return null;
    }
}